export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

export const PLAYER = {
  DRAG: 30,
  MAX_VELOCITY: 300,
  ACCELERATION: 200,
  ROTATION_SPEED: 200,
  MAX_HEALTH: 100,
  INVULNERABILITY_DURATION: 2000,
} as const;

export const TORPEDO = {
  DELAY: 250,
  SPEED: 400,
  LIFESPAN: 2000,
  DAMAGE: 2, // High damage per hit
} as const;

export const PHASER = {
  RANGE: 300,
  RELEASE_RANGE: 350,
  CONE_HALF_ANGLE: Math.PI / 6, // 30°
  RELEASE_CONE_HALF_ANGLE: Math.PI / 3, // 60°
  DPS: 2, // ~1.5s to kill large borg (3 HP), ~1s for medium, ~0.5s for small
  BEAM_WIDTH: 4,
  BEAM_COLOR: 0xff6600,
  BEAM_GLOW_COLOR: 0xffaa00,
} as const;

export const BORG = {
  LARGE: { size: 60, speed: 60, health: 3, points: 20 },
  MEDIUM: { size: 40, speed: 90, health: 2, points: 50 },
  SMALL: { size: 25, speed: 120, health: 1, points: 100 },
  MIN_SPAWN_DISTANCE: 150,
  DAMAGE: { large: 35, medium: 25, small: 15 },
} as const;

export const WAVES = {
  INITIAL_BORG_COUNT: 4,
  MAX_BORG_COUNT: 10,
  HEALTH_BONUS: 10,
  SPAWN_DELAY: 1500,
} as const;

export const THRUST = {
  SOUND_COOLDOWN: 100,
  FLAME_OFFSET: 20,
} as const;

export const SCREEN_WRAP_PADDING = 20;
